import { graphql, Link, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import * as styles from "/src/components/Footer.module.css";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF";
import { FaLinkedin } from "@react-icons/all-files/fa/FaLinkedin";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { FaRegCopyright } from "@react-icons/all-files/fa/FaRegCopyright";
import { v4 as uuidv4 } from "uuid";
import slugify from "slugify";

export default function Footer() {
  const data = useStaticQuery(query);
  const projectData = data.allContentfulProject.nodes.map(
    (val) => val["title"]
  );
  const blogData = data.allContentfulBlogPost.nodes.map((val) => val["title"]);
  const linkList = [
    { name: "about", links: ["Our story", "Team", "Benefits", "Careers"] },
    {
      name: "projects",
      links: projectData,
    },
    {
      name: "blog",
      links: blogData,
    },
    // {
    //   name: "Legal",
    //   links: ["Terms & Conditions", "Privacy Policy", "Terms of Use"],
    // },
  ];
  return (
    <footer className={styles.footerContainer}>
      <div className={styles.mainContent}>
        <div className={styles.infoSection}>
          <Link to="/">
            <StaticImage
              alt="Mgorium Logo"
              src="../images/logo-white.png"
              width={200}
            />
          </Link>
        </div>
        <div className={styles.categoryWrapper}>
          {linkList.map((header) => {
            return (
              <div key={uuidv4()} className={`col-4 ${styles.linkSection}`}>
                <span>
                  <b>{header.name}</b>
                </span>
                {header.links.map((entry) => {
                  return (
                    <ul key={uuidv4()}>
                      <Link
                        className={styles.link}
                        to={
                          header.name === "about"
                            ? "/about"
                            : `/${header.name.toLowerCase()}/${slugify(entry, {
                                lower: true,
                                strict: true,
                              })}`
                        }
                      >
                        <li>{entry}</li>
                      </Link>
                    </ul>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.bottomContainer}>
        <div className={styles.socialMedia}>
          <Link to="/">
            <FaFacebookF />
          </Link>
          <a href="https://www.linkedin.com/company/magorium-pte-ltd/">
            <FaLinkedin />
          </a>
          <Link to="/">
            <FaInstagram />
          </Link>
          <Link to="/">
            <FaTwitter />
          </Link>
        </div>
        <div className={styles.copyrightContainer}>
          All rights reserved by Magorium {new Date().getFullYear()}
          <FaRegCopyright style={{ marginLeft: 5 }} />
        </div>
      </div>
    </footer>
  );
}

export const query = graphql`
  {
    allContentfulProject(limit: 4, sort: { fields: createdAt }) {
      nodes {
        title
      }
    }
    allContentfulBlogPost(limit: 4, sort: { fields: createdAt }) {
      nodes {
        title
      }
    }
  }
`;
